import { IApplicationState } from '../../types/redux';

export const selectSeoQuery = (state: IApplicationState): string | undefined => {
  return state.offersData.seo?.query;
};
